module.exports = __webpack_public_path__ + "static/img/fruta.1ad03d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/fruta.png
// module id = 236
// module chunks = 1